import usecontactAccessStore from "../../store/contactAccessStore";

export const extractContactMenuAccess = () => {
    const { menuPermissionsList } = usecontactAccessStore.getState();
  if (!Array.isArray(menuPermissionsList)) return;

  // Helper: check top-level menu access
  const hasMenuAccess = (menuName) =>
    menuPermissionsList.some(
      (menu) =>
        menu.webMenuName === menuName &&
        menu.parentWebMenuId === 0 &&
        menu.isChecked === 1
    );

  // Helper: check submenu access under specific parent
  const hasSubMenuAccess = (parentMenuName, subMenuName) => {
    const parent = menuPermissionsList.find(
      (menu) =>
        menu.webMenuName === parentMenuName &&
        menu.parentWebMenuId === 0
    );

    if (!parent) return false;

    return menuPermissionsList.some(
      (menu) =>
        menu.webMenuName === subMenuName &&
        menu.parentWebMenuId === parent.webMenuId &&
        menu.isChecked === 1
    );
  };

  // 🔹 Get Assets parent
  const assetsParent = menuPermissionsList.find(
    (menu) =>
      menu.webMenuName === "Assets" &&
      menu.parentWebMenuId === 0 &&
      menu.isChecked === 1
  );

  // 🔹 Extract default asset submenu
  let defaultAssetSubMenu = null;

  if (assetsParent) {
    const assetSubMenus = menuPermissionsList
      .filter(
        (menu) =>
          menu.parentWebMenuId === assetsParent.webMenuId &&
          menu.isChecked === 1
      )
      .sort((a, b) => a.assetSubMenuOrder - b.assetSubMenuOrder);

    // Priority 1: Explicit default flag
    defaultAssetSubMenu =
      assetSubMenus.find((menu) => menu.isDefaultAssetSubMenu) ||
      assetSubMenus[0] || // fallback to first ordered submenu
      null;
  }

  // Extract flags
  const flags = {
    canAccessAssets: hasMenuAccess("Assets"),
    canAccessStatements: hasMenuAccess("Statements"),
    canAccessDocuments: hasMenuAccess("Documents"),
    canAccessResearchDocuments: hasMenuAccess("Research Documents"),

    // Asset submenus
    canAccessOverview: hasSubMenuAccess("Assets", "Overview"),
    canAccessDetails: hasSubMenuAccess("Assets", "Details"),
    canAccessHoldings: hasSubMenuAccess("Assets", "Holdings"),
  };

  return {flags, defaultAssetSubMenu}
};